import React, { useState } from "react"
import "./adminLogin.css"
import { AdminLoginComp } from "../../components/admin-login/AdminLoginComp"
import { PasswordRestComp } from "../../components/password-reset/PasswordResetComp"

export const AdminLoginPage = () => {
  const [formLoad, setformLoad] = useState("login")

  const formSwitched = (formType) => {
    setformLoad(formType)
  }
  return (
    <div className="admin-page bg-light">
      <div className="jumbotron form-box p-4 pt-5">
        {formLoad === "login" && <AdminLoginComp formSwitched={formSwitched} />}

        {formLoad === "reset" && (
          <PasswordRestComp formSwitched={formSwitched} />
        )}
      </div>
    </div>
  )
}

export default AdminLoginPage
